module.exports = __webpack_public_path__ + "static/media/fullscreen-icon.3ee297c4.svg";